import {Props_ImageContentAlternative} from "./ImageContentAlternative.props";
import {CompileMarkdown} from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import SnippetLink from "../Shared/Link/Link";
import { motion } from "framer-motion";
import React from "react";

const ImageContentAlternative = (props: Props_ImageContentAlternative) => {
    const {image, decorativeImage, text, repeatable_link, heading, background, overlap} = props
    const isOverlappingClass = overlap?.enabled?.value === 'overlap' ? 'image-content-alternative--overlap' : ''

    const backgroundMap = {
        'covea-dark-blue': '#122147',
        'covea-light-green': '#d6eac1',
        'covea-light-red': '#efded3',
        'covea-light-purple': '#e2d3f2',
        'covea-light-turquoise': '#c8eaed',
        'covea-light-yellow': '#eae8ad',
        'MAAF-dark-blue': '#0091a7',
        'MAAF-light-blue': '#e5f3f5',
        'MAAF-light-red': '#fef6f2',
        'MMA-light-green': '#d6eceb',
        'MMA-light-orange': '#f2e1b5',
        'MMA-dark-blue': '#1d3b6d',
        'GMF-dark-blue': '#144390',
        'GMF-light-blue': '#dfedff',
        'GMF-light-orange': '#fff4ed',
        'Fidelia-dark-green': '#269b38',
        'Fidelia-light-blue': '#e1f0fb',
        'Fidelia-light-green': '#ebf2e7'
    }

    const backgroundKey = background?.[0]?.value || 'covea-dark-blue'
    const backgroundValue = backgroundMap[backgroundKey as keyof typeof backgroundMap]
    const darkBackgrounds = ['covea-dark-blue', 'MAAF-dark-blue', 'MMA-dark-blue', 'GMF-dark-blue', 'Fidelia-dark-green']
    const useDarkText = !darkBackgrounds.includes(backgroundKey) ? 'image-content-alternative--dark-text' : ''
    
    return (
        <section className={`image-content-alternative ${isOverlappingClass} ${useDarkText}`}>
            <div className='image-content-alternative__content' style={{backgroundColor: backgroundValue}}>
                <div className='image-content-alternative__content-inner'>
                    {decorativeImage?.src?.value && 
                        <motion.img 
                            className='image-content-alternative__decorative-image'
                            src={decorativeImage.src.value}
                            alt={decorativeImage?.alt?.value || ''}
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            transition={{ 
                                duration: 0.8, 
                                ease: "easeOut",
                                delay: 0.2
                            }}
                            viewport={{ once: true, amount: 0.9 }}
                        />
                    }
                    {heading?.content?.value &&
                        <h2 className='image-content-alternative__heading'>{heading.content.value}</h2>
                    }
                    <div className='image-content-alternative__text-content'>
                        {text?.content?.value && CompileMarkdown(text?.content?.value)}
                    </div>
                    <div className='image-content-alternative__links'>
                        {repeatable_link?.map((link, index) => (
                            <SnippetLink
                                key={`hero-link-${index}`}
                                url={link.linkHref?.value || link.linkHref?.value}
                                linkStyles={link.linkStyle?.value}
                                openInNewTab={link.linkTarget?.value}
                            >
                                {link.linkText?.value || link.linkText?.value}
                                <span className="image-content-alternative__accessible-content">{link.linkAccessibleContent?.value}</span>
                            </SnippetLink>
                        ))}
                    </div>
                </div>
            </div>
            {image?.src?.value &&
                <figure className='image-content-alternative__image-container'>
                    <img 
                        src={image.src.value}
                        alt={image?.alt?.value || 'Image'}
                        className='image-content-alternative__image'
                        loading="lazy"
                        height="400"
                        width="600"
                    />
                </figure>
            }
            
        </section>
    )
}

export default ImageContentAlternative